import { isObject } from 'underscore';

// https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
declare global {
  interface Window {
    scheduler?: unknown;
  }
}

type TUnknownFn = (...args: unknown[]) => unknown;

/** see [Prioritized_Task_Scheduling_API](https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API) for types */
const createScheduler = () => {
  if ('scheduler' in window) {
    const scheduler = window.scheduler;
    if (isObject(scheduler) && 'postTask' in scheduler && 'yield' in scheduler) {
      return {
        async schedule(task: TUnknownFn, options = {}) {
          return scheduler.postTask(task, options);
        },
        async yield() {
          return scheduler.yield();
        },
      };
    }
  }

  return {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async schedule(task: TUnknownFn, { delay = 0, priority = 'background' } = {}) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          try {
            resolve(task());
          } catch (error) {
            reject(error);
          }
        }, delay);
      });
    },
    async yield() {
      return new Promise((resolve) => setTimeout(resolve, 0));
    },
  };
};

export default createScheduler;
